import axios from 'axios';
import router from "@/router";

// type : 0= (common apis) 1 =(user apis)

export default class ApiService {
  StorageObjUserRef = localStorage.user_reference;
  StorageObjAdmin = localStorage.user ? localStorage.user : '';
  StorageObjMasterBucket = localStorage.masterBucketName ? localStorage.masterBucketName : '';
  admin = this.StorageObjAdmin.user_id ? this.StorageObjAdmin.user_id : '';
  user = localStorage.user;
  // StorageObjClient = localStorage.client_info ? JSON.parse(localStorage.client_info) : "";
  // client = this.StorageObjClient.maa1 ? this.StorageObjClient.maa1 : "";

  HeaderParam = {
    "Access-Control-Allow-Origin": "*",
    'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
    'content-type': 'application/json',
    'Accept': 'application/json',
  };

  AuthenticatedUserHeader = {
    "Access-Control-Allow-Origin": "*",
    'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
    'content-type': 'application/json',
    'Accept': 'application/json',
    'Authorization': "Bearer " + this.StorageObjUserRef,
    user: this.user,
    // client: this.client,
  };

  commonapiall = (url, params, method, type, item) => {
    return axios(url, {
      baseURL: location.origin,
      method: method,
      headers: params,
      data: item,
    })
      .then(response => {
        if (response.data.status == 403) {
          this.userlogout();
        }
        return response.data;
      })
      .catch(error => {
        throw error;
      });
  };

  login(item) {
    let url = 'api/login';
    return this.commonapiall(url, this.HeaderParam, 'POST', 0, item);
  }

  userlogout = (item) => {
    const URL = 'api/userlogout';
    return axios(URL, {
      method: 'POST',
      baseURL: location.origin,
      headers: this.AuthenticatedUserHeader,
      data: item,
    })
      .then(response => {
        localStorage.clear();
        router.push({ path: '/login' });
        return response.data;
      })
      .catch(error => {
        throw error;
      });
  }

  getAdminUsersList(item) {
    let url = 'api/u/getAdminUsersList';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }

  getStates(item) {
    let url = 'api/common/getStates';
    return this.commonapiall(url, this.HeaderParam, 'POST', 0, item);
  }

  getCities(item) {
    let url = 'api/common/getCities';
    return this.commonapiall(url, this.HeaderParam, 'POST', 0, item);
  }

  createUpdateAdminUser(item) {
    let url = 'api/u/createAdminUserFirstStep';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }

  getAdminUserDetails(item) {
    let url = 'api/u/getAdminUserDetails';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }

  updateAdminUserconfig(item) {
    let url = 'api/u/updateAdminUserconfig';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }

  getMasterPlans(item) {
    let url = 'api/common/getMasterPlans';
    return this.commonapiall(url, this.HeaderParam, 'POST', 0, item);
  }

  getExistingPlanComponents(item) {
    let url = 'api/u/getExistingPlanComponents';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }

  getPlanComponents(item) {
    let url = 'api/u/getPlanComponents';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }

  doActionClientPlanComponentUpdate(item) {
    let url = 'api/u/doActionClientPlanComponentUpdate';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }

  assignPlanToclient(item) {
    let url = 'api/u/assignPlanToclient';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }

  getRequestForPlanChange(item) {
    let url = 'api/u/getRequestForPlanChange';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }

  getAdminUsersOnly(item) {
    let url = 'api/u/getAdminUsersOnly';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }

  createUpdateAdminUserRole(item) {
    let url = 'api/u/createUpdateAdminUserRole';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }

  removeAssignedRoles(item) {
    let url = 'api/u/removeAssignedRoles';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }

  getAllAdminUserDetails(item) {
    let url = 'api/u/getAllAdminUserDetails';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }

  getAdminDocumentDetails(item) {
    let url = 'api/u/getAdminDocumentDetails';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }

  addUpdateAdminDocuments(payload) {
    let url = 'api/u/addUpdateAdminDocuments';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }

  getAdminListOnly(item) {
    let url = 'api/u/getAdminListOnly';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }
  getAdminListForDIDNumber(item) {
    let url = 'api/u/getAdminListForDIDNumber';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }
  getDIDNumberByCLientId(item) {
    let url = 'api/u/getDIDNumberByCLientId';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }
  getCallSettingList(item) {
    let url = 'api/u/getCallSettingList';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }
  insertOrUpdateCallSetting(item) {
    let url = 'api/u/insertOrUpdateCallSetting';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }
  getSuperAdminUserListForAppSupport(item) {
    let url = 'api/u/getSuperAdminUserListForAppSupport';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }

  getHostListOnly(item) {
    let url = 'api/u/getHostListOnly';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }

  getHostUserDetails(item) {
    let url = 'api/u/getHostUserDetails';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }

  getHostBranchesOnly(item) {
    let url = 'api/common/getHostBranchesOnly';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }

  getHostBranchesUserDetails(item) {
    let url = 'api/u/getHostBranchesUserDetails';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }

  getAdminFund(item) {
    let url = 'api/u/getClientFund';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }

  getBillingCompany(item) {
    let url = 'api/common/getBillingCompany';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }

  addAdminFund(item) {
    let url = 'api/u/addClientFund';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }

  getAdminDebitDetails(item) {
    let url = 'api/u/getClientDebitDetails';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }

  getTaxInvoices(item) {
    let url = 'api/u/getTaxInvoices';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }

  getTaxInvoiceComponent(item) {
    let url = 'api/u/getTaxInvoiceComponent';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }

  getPaymentReceipts(item) {
    let url = 'api/u/getPaymentReceipts';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }

  regeneratePaymentReceipt(item) {
    let url = 'api/u/regeneratePaymentReceipt';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }

  getAllPlans(item) {
    let url = 'api/u/getAllPlans';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }

  addUpdatePlan(item) {
    let url = 'api/u/addUpdatePlan';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }

  getPlanDetails(item) {
    let url = 'api/u/getPlanDetails';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }

  getComponentName(item) {
    let url = 'api/common/getComponentName';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }

  createPlanConfig(item) {
    let url = 'api/u/createPlanConfig';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }

  updatePlanConfig(item) {
    let url = 'api/u/updatePlanConfig';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }

  getLiveBalance(item) {
    let url = 'api/u/getLiveBalance';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }

  getComponentList(item) {
    let url = 'api/common/getComponentList';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }

  addComponentDebitAction(item) {
    let url = 'api/u/addComponentDebitAction';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }

  getClientServiceSettings(item) {
    let url = 'api/u/getClientServiceSettings';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }

  addClientServiceSettings(item) {
    let url = 'api/u/addClientServiceSettings';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }

  getTemplateActions(item) {
    let url = 'api/u/getTemplateActions';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }

  getWhatsAppTemplateSettings(item) {
    let url = 'api/u/getWhatsAppTemplateSettings';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }

  getAllTemplateDescriptions(item) {
    let url = 'api/u/getAllTemplateDescriptions';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }

  getchatbotList(item) {
    let url = 'api/common/getchatbotList';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }

  getTitles(item) {
    let url = 'api/common/getTitles';
    return this.commonapiall(url, this.HeaderParam, 'POST', 0, item);
  }

  getSuperAdminUserList(item) {
    let url = 'api/u/getSuperAdminUserList';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }

  createUpdateSuperAdminUser(item) {
    let url = 'api/u/createUpdateSuperAdminUser';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }

  getDIDNumberByStatus(item) {
    let url = 'api/u/getDIDNumberByStatus';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }

  getAllDefaultTunes(item) {
    let url = 'api/u/getAllDefaultTunes';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }

  createUpdateAllDefaultTunes(item) {
    let url = 'api/u/createUpdateAllDefaultTunes';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }

  isAlreadyPresentTemplateDescriptionId(item) {
    let url = 'api/u/isAlreadyPresentTemplateDescriptionId';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }

  createUpdateTemplateDescription(item) {
    let url = 'api/u/createUpdateTemplateDescription';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }

  addDIDNumber(item) {
    let url = 'api/u/addDIDNumber';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }

  updateDIDNumber(item) {
    let url = 'api/u/updateDIDNumber';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }

  getAllTemplateOnly(item) {
    let url = 'api/common/getAllTemplateOnly';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }

  getAdminTemplateActionsOnly(item) {
    let url = 'api/common/getAdminTemplateActionsOnly';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }

  getTemplateEvents(item) {
    let url = 'api/u/getTemplateEvents';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }

  addUpdateTemplateEvents(item) {
    let url = 'api/u/addUpdateTemplateEvents';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }

  getCurrentTemplateEvents(item) {
    let url = 'api/u/getCurrentTemplateEvents';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }

  getCurrentWPTemplateEvents(item) {
    let url = 'api/u/getCurrentWPTemplateEvents';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }

  getCurrentEmailTemplateEvents(item) {
    let url = 'api/u/getCurrentEmailTemplateEvents';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }

  getCurrentRCSTemplateEvents(item) {
    let url = 'api/u/getCurrentRCSTemplateEvents';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }

  getTemplateDescriptions(item) {
    let url = 'api/u/getTemplateDescriptions';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }

  isAlreadyPresentTemplateName(item) {
    let url = 'api/u/isAlreadyPresentTemplateName';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }

  copywhatsAppSettingToOtherClient(item) {
    let url = 'api/u/copywhatsAppSettingToOtherClient';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }

  addUpdateClientwhatsAppTemplates(item) {
    let url = 'api/u/addUpdateClientwhatsAppTemplates';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }

  getRCSTemplateSettings(item) {
    let url = 'api/u/getRCSTemplateSettings';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }

  addUpdateEventWhatsAppTemplateSettings(item) {
    let url = 'api/u/addUpdateEventWhatsAppTemplateSettings';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }

  addUpdateEventRCSTemplateSettings(item) {
    let url = 'api/u/addUpdateEventRCSTemplateSettings';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }

  addUpdateEventEmailTemplateSettings(item) {
    let url = 'api/u/addUpdateEventEmailTemplateSettings';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }

  getAllRCSTemplateOnly(item) {
    let url = 'api/common/getAllRCSTemplateOnly';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }

  isAlreadyPresentRCSTemplateName(item) {
    let url = 'api/u/isAlreadyPresentRCSTemplateName';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }

  addUpdateClientRCSTemplates(item) {
    let url = 'api/u/addUpdateClientRCSTemplates';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }
  getHostDetails(item) {
    let url = 'api/u/getHostDetails';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }
  getHostAllDetails(item) {
    let url = 'api/u/getHostAllDetails';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }
  getHostBranchesDetails(item) {
    let url = "api/u/getHostBranchesDetails";
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }
  copyRCSSettingToOtherClient(item) {
    let url = 'api/u/copyRCSSettingToOtherClient';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }

  getClientsAccountStatementDetails(item) {
    let url = 'api/u/getClientsAccountStatementDetails';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }
  getClientsTaxInvoicesDetails(item) {
    let url = 'api/u/getClientsTaxInvoicesDetails';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }
  getClientsPaymentReceiptDetails(item) {
    let url = 'api/u/getClientsPaymentReceiptDetails';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }

  getAllVisitorsDetails(item) {
    let url = 'api/u/getAllVisitorsDetails';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }

  getAllVisitorsDetailsByHost(item) {
    let url = 'api/u/getAllVisitorsDetailsByHost';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }

  getAllVisitorsDetailsByBranches(item) {
    let url = 'api/u/getAllVisitorsDetailsByBranches';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }

  getCurrentSMSTemplateEvents(item) {
    let url = 'api/u/getCurrentSMSTemplateEvents';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }
  addUpdateEventSMSTemplateSettings(item) {
    let url = 'api/u/addUpdateEventSMSTemplateSettings';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }
  updateAdminUserCriticalPermissions(item) {
    let url = 'api/u/updateAdminUserCriticalPermissions';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }

  getAdminUserCriticalPermissions(item) {
    let url = 'api/u/getAdminUserCriticalPermissions';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }

  getTicketsByStatus(item) {
    let url = 'api/u/getTicketsByStatus';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 0, item);
  }

  getTicketsMessage(item) {
    let url = 'api/u/getTicketMessages';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 0, item);
  }

  assignTicket(payload) {
    let url = 'api/u/assignTicket';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }

  getMyAndTeamAssignTicket(payload) {
    let url = 'api/u/getMyAssignAndTeamTicketList';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }

  chat(payload) {
    let url = 'api/u/chat';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }

  closeTicket(payload) {
    let url = 'api/u/closeTicket';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }

  triggercalltomeranetaclients(payload) {
    let url = 'api/u/triggercalltomeranetaclients';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }

  getAreaList(payload) {
    let url = 'api/common/getAreaList';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }

  getAdminUserRoles(payload) {
    let url = 'api/common/getAdminUserRoles';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }

  checkUserMobileisAlreadyPresent(payload) {
    let url = 'api/u/checkUserMobileisAlreadyPresent';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }

  createUpdateAdminUsers(payload) {
    let url = 'api/u/createUpdateAdminUsers';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }

  getAllAdminUserRoleDetails(item) {
    let url = 'api/u/getAllAdminUserRoleDetails';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }

  getAdminUsersNotHavingRoles(item) {
    let url = 'api/common/getAdminUsersNotHavingRoles';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }

  getActiveUsers(item) {
    let url = 'api/common/getActiveSuperAdminUsers';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }

  getLanguages(item) {
    let url = 'api/common/getLanguages';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 0, item);
  }

  getAdminListOnlyExceptGivenId(payload) {
    let url = 'api/common/getAdminListOnlyExceptGivenId';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }

  copyTemplateActionToOtherAdmin(payload) {
    let url = 'api/u/copyTemplateActionToOtherAdmin';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }

  getCompaniesList(payload) {
    let url = 'api/u/getCompaniesList';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }

  createUpdateCompanies(payload) {
    let url = 'api/u/createUpdateCompanies';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }

  getcompanyListOnly(payload) {
    let url = 'api/common/getcompanyListOnly';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }

  getCompaniesSenderIdList(payload) {
    let url = 'api/u/getCompaniesSenderIdList';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }

  createUpdateCompaniesSenderId(payload) {
    let url = 'api/u/createUpdateCompaniesSenderId';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }

  // -----------------Super Admin Template Setting Related End Points Start-----------

  getSuperAdminTemplateActions(payload) {
    let url = 'api/u/getSuperAdminTemplateActions';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }

  getSuperAdminTemplateActionsOnly(payload) {
    let url = 'api/common/getSuperAdminTemplateActionsOnly';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }

  getSuperAdminTemplateEvents(payload) {
    let url = 'api/u/getSuperAdminTemplateEvents';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }

  addUpdateSuperAdminTemplateEvents(payload) {
    let url = 'api/u/addUpdateSuperAdminTemplateEvents';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }

  getCurrentSuperAdminTemplateEvents(payload) {
    let url = 'api/u/getCurrentSuperAdminTemplateEvents';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }

  getCurrentSuperAdminWPTemplateEvents(payload) {
    let url = 'api/u/getCurrentSuperAdminWPTemplateEvents';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }

  getCurrentSuperAdminEmailTemplateEvents(payload) {
    let url = 'api/u/getCurrentSuperAdminEmailTemplateEvents';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }

  getCurrentSuperAdminRCSTemplateEvents(payload) {
    let url = 'api/u/getCurrentSuperAdminRCSTemplateEvents';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }

  addUpdateSuperAdminEventWhatsAppTemplateSettings(payload) {
    let url = 'api/u/addUpdateSuperAdminEventWhatsAppTemplateSettings';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }

  addUpdateSuperAdminEventEmailTemplateSettings(payload) {
    let url = 'api/u/addUpdateSuperAdminEventEmailTemplateSettings';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  addUpdateSuperAdminEventRCSTemplateSettings(payload) {
    let url = 'api/u/addUpdateSuperAdminEventRCSTemplateSettings';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }

  getCurrentSuperAdminSMSTemplateEvents(payload) {
    let url = 'api/u/getCurrentSuperAdminSMSTemplateEvents';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }

  addUpdateSuperAdminEventSMSTemplateSettings(payload) {
    let url = 'api/u/addUpdateSuperAdminEventSMSTemplateSettings';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }

  getAllWebBotTemplateOnly(payload) {
    let url = 'api/u/getAllWebBotTemplateOnly';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }

  getWebBotTemplateSettings(payload) {
    let url = 'api/u/getWebBotTemplateSettings';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }

  isAlreadyPresentWebBotTemplateName(payload) {
    let url = 'api/u/isAlreadyPresentWebBotTemplateName';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }

  addUpdateClientWebBotTemplates(payload) {
    let url = 'api/u/addUpdateClientWebBotTemplates';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }

  getSuperAdminWhatsAppTemplateEventsOnly(payload) {
    let url = 'api/common/getSuperAdminWhatsAppTemplateEventsOnly';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }

  getSuperAdminRCSTemplateEventsOnly(payload) {
    let url = 'api/common/getSuperAdminRCSTemplateEventsOnly';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  // -----------------Super Admin Template Setting Related End Points End-----------

  // -----------------Admin Template Setting Related start Points End-----------

  getAdminTemplateActions(payload) {
    let url = 'api/u/getAdminTemplateActions';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  getCurrentAdminTemplateEvents(payload) {
    let url = "api/u/getCurrentAdminTemplateEvents";
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  getCompaniesSenderIdOnly(payload) {
    let url = "api/common/getCompaniesSenderIdOnly";
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  getDashboardLogoUploadDetails(payload) {
    let url = "api/u/getDashboardLogoUploadDetails";
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  createUpdateDashboardLogos(payload) {
    let url = "api/u/createUpdateDashboardLogos";
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  getLanguagesExceptHindiAndEnglish(payload) {
    let url = 'api/common/getLanguagesExceptHindiAndEnglish';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  getchatbotListing(payload) {
    let url = "api/u/getchatbotListing";
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  createUpdateChatBotIds(payload) {
    let url = "api/u/createUpdateChatBotIds";
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  getMaximumTemplateDescriptionCount(payload) {
    let url = "api/u/getMaximumTemplateDescriptionCount";
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  getTemplateDescriptionOfSubSequenceIds(payload) {
    let url = "api/u/getTemplateDescriptionOfSubSequenceIds";
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  getCurrentWebBotTemplateBody(payload) {
    let url = "api/u/getCurrentWebBotTemplateBody";
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  getCurrentWebBotAppTemplate(payload) {
    let url = "api/u/getCurrentWebBotAppTemplate";
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  getCurrentMultiflowTempList(payload) {
    let url = "api/u/getCurrentMultiflowTempList";
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  getCurrentWebBotsAppMultiflowTemplates(payload) {
    let url = "api/u/getCurrentWebBotsAppMultiflowTemplates";
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  getWebBotFlowData(payload) {
    let url = "api/u/getWebBotFlowData";
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  addWebBotFlow(payload) {
    let url = "api/u/addWebBotFlow";
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  getAllLiveVisitorsDetails(payload) {
    let url = "api/u/getAllLiveVisitorsDetails";
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  getMenus(payload) {
    let url = "api/u/getMenus";
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  getSuperAdminRoles(payload) {
    let url = "api/u/getSuperAdminRoles";
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  getAllMenus(payload) {
    let url = "api/u/getAllMenus";
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'GET', 1, payload);
  }
  createUpdateUserPermissionSet(payload) {
    let url = "api/u/createUpdateUserPermissionSet";
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  getSuperAdminUserRolesListing(payload) {
    let url = "api/u/getSuperAdminUserRolesListing";
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  getAllLiveVisitorsDetailsByHost(payload) {
    let url = "api/u/getAllLiveVisitorsDetailsByHost";
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  getAllLiveVisitorsDetailsByBranches(payload) {
    let url = "api/u/getAllLiveVisitorsDetailsByBranches";
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  getAdminAccountStatement(payload) {
    let url = "api/u/getAdminAccountStatement";
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  getWhatsAppLogs(payload) {
    let url = "api/u/getWhatsAppLogs";
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  getWebBotLogs(payload) {
    let url = "api/u/getWebBotLogs";
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  getsmsLogs(payload) {
    let url = "api/u/getsmsLogs";
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  getIncomingCallLogs(payload) {
    let url = "api/u/getIncomingCallLogs";
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  getOutgoingCallLogs(payload) {
    let url = "api/u/getOutgoingCallLogs";
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  getHostUsersListOnly(payload) {
    let url = 'api/u/getHostUsersListOnly';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  getLoginAsAdmin(payload) {
    let url = 'api/u/getLoginAsAdmin';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  getLoginAsHost(payload) {
    let url = 'api/u/getLoginAsHost';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  getPoliceUsersDetails(payload) {
    let url = 'api/u/getPoliceUsersDetails';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  getcallbacknumbers(payload) {
    let url = 'api/u/getcallbacknumbers';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  triggercalltovisitorconnect(payload) {
    let url = 'api/u/triggercalltovisitorconnect';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  getGuestHistory(payload) {
    let url = 'api/u/getGuestHistory';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  getCallRecordings(payload) {
    let url = 'api/u/getCallRecordings';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  getUsersCriticalPermissions(payload) {
    let url = 'api/u/getUsersCriticalPermissions';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  addUsersCriticalPermissions(payload) {
    let url = 'api/u/addUsersCriticalPermissions';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  getWebBotFlowSettingData(payload) {
    let url = 'api/u/getWebBotFlowSettingData';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  getCurrentWebBotTemplateSettings(payload) {
    let url = 'api/u/getCurrentWebBotTemplateSettings';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  addUpdateWebBotFlowSettingData(payload){
    let url = 'api/u/addUpdateWebBotFlowSettingData';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);  
  }
  getModuleSetting(payload){
    let url = 'api/u/getModuleSettingsForBilling';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  addModuleSettingsForBilling(item) {
    let url = 'api/u/addModuleSettingsForBilling';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }
  getAllAdminMenus(item) {
    let url = "api/u/getAllAdminMenus";
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }
  updateAdminMenuPermissions(item) {
    let url = "api/u/updateAdminMenuPermissions";
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }
  getAllComponents(item) {
    let url = "api/u/getAllComponents";
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }
  getComponentChargesList(item) {
    let url = "api/u/getComponentChargesList";
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }
  updateComponentCharges(item) {
    let url = "api/u/updateComponentCharges";
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }
  getFIRRequestType(item) {
    let url = "api/u/getFIRRequestType";
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }
  insertOrUpdateFIRRequestType(item) {
    let url = "api/u/insertOrUpdateFIRRequestType";
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }
  removeFIRRequestType(item) {
    let url = "api/u/removeFIRRequestType";
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }
  getFIRRequestSubType(item) {
    let url = "api/u/getFIRRequestSubType";
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }
  insertOrUpdateFIRRequestSubType(item) {
    let url = "api/u/insertOrUpdateFIRRequestSubType";
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }
  removeFIRRequestSubType(item) {
    let url = "api/u/removeFIRRequestSubType";
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, item);
  }
  getFIRRequestTypeList(payload) {
    let url = 'api/u/getFIRRequestTypeList';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  getPCCApplicationType(payload) {
    let url = 'api/u/getPCCApplicationType';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  insertOrUpdatePCCApplicationType(payload) {
    let url = 'api/u/insertOrUpdatePCCApplicationType';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  removePCCApplicationType(payload) {
    let url = 'api/u/removePCCApplicationType';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  getTypeOfIndustries(payload) {
    let url = 'api/u/getTypeOfIndustries';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  insertOrUpdateTypeOfIndustries(payload) {
    let url = 'api/u/insertOrUpdateTypeOfIndustries';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  removeTypeOfIndustries(payload) {
    let url = 'api/u/removeTypeOfIndustries';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  getReportReason(payload) {
    let url = 'api/u/getReportReason';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  insertOrUpdateReportReason(payload) {
    let url = 'api/u/insertOrUpdateReportReason';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  removeReportReason(payload) {
    let url = 'api/u/removeReportReason';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  getCompanyType(payload) {
    let url = 'api/u/getCompanyType';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  insertOrUpdateCompanyType(payload) {
    let url = 'api/u/insertOrUpdateCompanyType';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  removeCompanyType(payload) {
    let url = 'api/u/removeCompanyType';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  getIPCSection(payload) {
    let url = 'api/u/getIPCSection';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  insertOrUpdateIPCSection(payload) {
    let url = 'api/u/insertOrUpdateIPCSection';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  removeIPCSection(payload) {
    let url = 'api/u/removeIPCSection';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  getEmployments(payload) {
    let url = 'api/u/getEmployments';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  insertOrUpdateEmployments(payload) {
    let url = 'api/u/insertOrUpdateEmployments';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  removeEmployments(payload) {
    let url = 'api/u/removeEmployments';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  getClientMenus(payload) {
    let url = 'api/u/getClientMenus';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  insertOrUpdateClientMenus(payload) {
    let url = 'api/u/insertOrUpdateClientMenus';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  removeClientMenus(payload) {
    let url = 'api/u/removeClientMenus';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  getClientMenusById(payload) {
    let url = 'api/u/getClientMenusById';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  getAllCountries(payload) {
    let url = 'api/u/getAllCountries';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  insertOrUpdateCountries(payload) {
    let url = 'api/u/insertOrUpdateCountries';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  getAllStates(payload) {
    let url = 'api/u/getAllStates';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  insertOrUpdateStates(payload) {
    let url = 'api/u/insertOrUpdateStates';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  getCountries(payload) {
    let url = 'api/common/getCountries';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  getAllDistricts(payload) {
    let url = 'api/u/getAllDistricts';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  insertOrUpdateDistricts(payload) {
    let url = 'api/u/insertOrUpdateDistricts';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  getAllCities(payload) {
    let url = 'api/u/getAllCities';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  insertOrUpdateCities(payload) {
    let url = 'api/u/insertOrUpdateCities';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  getDistricts(payload) {
    let url = 'api/common/getDistricts';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  getAllAreas(payload) {
    let url = 'api/u/getAllAreas';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  insertOrUpdateAreas(payload) {
    let url = 'api/u/insertOrUpdateAreas';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  getDynamicScreenMessage(payload) {
    let url = 'api/u/getDynamicScreenMessage';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  insertOrUpdateDynamicScreenMessage(payload) {
    let url = 'api/u/insertOrUpdateDynamicScreenMessage';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  updateCallAndCumminicationPermissionStatus(payload) {
    let url = 'api/u/updateCallAndCumminicationPermissionStatus';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  getCallCenterSetting(payload) {
    let url = 'api/u/getCallCenterSetting';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  getVirtualNumberByClientId(payload) {
    let url = 'api/u/getVirtualNumberByClientId';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  assignVirtualNumberToCallCenter(payload) {
    let url = 'api/u/assignVirtualNumberToCallCenter';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  updateCumminicationPermissionStatus(payload) {
    let url = 'api/u/updateCumminicationPermissionStatus';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  updateCallPermissionStatus(payload) {
    let url = 'api/u/updateCallPermissionStatus';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  getCallLsit(payload) {
    let url = 'api/common/getCallLsit';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  addCallListWithVirtualNumberToCallCenter(payload) {
    let url = 'api/u/addCallListWithVirtualNumberToCallCenter';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  getPaymentGatwayDetails(payload) {
    let url = 'api/u/getPaymentGatwayDetails';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  insertOrUpdategetPaymentGatwayDetails(payload) {
    let url = 'api/u/insertOrUpdategetPaymentGatwayDetails';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  getCurrentPushNotificationEvents(payload) {
    let url = 'api/v1/u/getCurrentPushNotificationEvents';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  addUpdateEventpnTemplateSettings(payload) {
    let url = 'api/v1/u/addUpdateEventpnTemplateSettings';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  multipleUpdateFIRRequestTypes(payload) {
    let url = 'api/u/multipleUpdateFIRRequestTypes';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  getWeekDays(payload) {
    let url = 'api/u/getWeekDays';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  getPaymentsFromClientDetails(payload) {
    let url = 'api/u/getPaymentsFromClientDetails';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  updatePaymentFromClientStatus(payload) {
    let url = 'api/u/updatePaymentFromClientStatus';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  getAppSupportCallLog(payload) {
    let url = 'api/u/getAppSupportCallLog';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  insertOrUpdateClientDashboardMessage(payload) {
    let url = 'api/u/insertOrUpdateClientDashboardMessage';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  getClientDashboardMessage(payload) {
    let url = 'api/u/getClientDashboardMessage';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  getRcsLogs(payload) {
    let url = 'api/u/getRcsLogs';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  getbloodgroups(payload) {
    let url = 'api/common/getbloodgroups';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  getPopUp(payload) {
    let url = 'api/u/getPopUp';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  addOrUpdatePopUp(payload) {
    let url = 'api/u/addOrUpdatePopUp';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  getAppVersionDetails(payload) {
    let url = 'api/u/getAppVersionDetails';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  addOrUpdateAppVersion(payload) {
    let url = 'api/u/addOrUpdateAppVersion';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  getAppUsageByUsersList(payload) {
    let url = 'api/u/getAppUsageByUsersList';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
   getCurrentCommunicatingToTemplateEvents(payload) {
    let url = 'api/v1/u/getCurrentCommunicatingToTemplateEvents';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  addUpdatecommunicatingToTemplateSettings(payload) {
    let url = 'api/v1/u/updateTemplateActionTakingStatus';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  getCommonConfigSettings(payload) {
    let url = 'api/u/getCommonConfigSettings';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  insertUpdateCommonConfig(payload) {
    let url = 'api/u/insertUpdateCommonConfig';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  updateConfigKeyEditStatus(payload) {
    let url = 'api/u/updateConfigKeyEditStatus';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  getStaticLogoList(payload) {
    let url = 'api/u/getStaticLogoList';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
  UpdateStaticLogo(payload) {
    let url = 'api/u/UpdateStaticLogo';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
    getClientLanguages(payload) {
    let url = 'api/common/getClientLanguages';
    return this.commonapiall(url, this.AuthenticatedUserHeader, 'POST', 1, payload);
  }
}